import React from "react";
import {
    NumberField,
    SwitchField,
} from "../../../../../../../Utils/renderField/fieldsHookForms";
import { IsAlmacenBultosSkim } from "../helpers/almacenSkim";
import { formatDisplayNumber } from "../../../../../../../../../utility/utils";
const conectadaIcon = require("assets/img/icons/conectada.png");
const desconectadaIcon = require("assets/img/icons/desconectada.png");

export const DatosBascula = (props) => {
    const { formControl, formValues, formErrors, basculaConectada } = props;

    const cargaManual = formValues.carga_manual;

    const esAlmacenBultosSkim = IsAlmacenBultosSkim(formValues);
    const bultoSkim = formValues.bulto_skim;

    const getMaxKgHumedos = () => {
        if (esAlmacenBultosSkim && bultoSkim) {
            return bultoSkim.kg_humedos_actual;
        } else {
            return 99999999999;
        }
    };

    return (
        <React.Fragment>
            <div
                className="d-flex justify-content-between py-4 px-3 gap-1rem flex-wrap"
                style={{ backgroundColor: "#ebebeb", borderRadius: "1rem" }}
            >
                <div
                    className="formulario-field horizontal justify-content-center"
                    style={{ marginTop: "6px" }}
                >
                    <label className="text-nowrap mb-0 mr-1">Báscula:</label>
                    <div className="d-flex align-items-center gap-10">
                        <img
                            src={basculaConectada ? conectadaIcon : desconectadaIcon}
                            alt="estado báscula"
                            style={{ width: "20px", height: "20px" }}
                        />
                        <span>
                            {basculaConectada ? "Conectada" : "Desconectada"}
                        </span>
                    </div>
                </div>

                <div className="formulario-field horizontal justify-content-center align-items-start min-w-200">
                    <label className="text-nowrap mt-1">
                        {cargaManual ? "Peso manual" : "Peso báscula"}
                    </label>
                    <NumberField
                        control={formControl}
                        name="kg_humedos"
                        errors={formErrors}
                        allowNegative={false}
                        suffix=" Kg"
                        rules={{
                            required: "Este campo es obligatorio",
                            min: {
                                value: 1,
                                message: "Debe ser al menos 1",
                            },
                            max: {
                                value: getMaxKgHumedos(),
                                message: `No puede superar ${formatDisplayNumber(getMaxKgHumedos(), 2)} Kg`,
                            },
                        }}
                        decimalScale={2}
                        disabled={!cargaManual}
                    />
                </div>

                <div className="d-flex justify-content-center mt-1 flex-1">
                    <SwitchField
                        name="carga_manual"
                        control={formControl}
                        label="Agregar carga manual"
                    />
                </div>
            </div>
        </React.Fragment>
    );
};
